import { effect, inject, Injectable, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
 providedIn: 'root',
})
export class UpdateCheckerService {
 private readonly swUpdate = inject(SwUpdate);
 readonly updateDetected = signal(false);
 readonly updateReady = signal(false);

 constructor() {
  if (this.swUpdate.isEnabled) {
   effect(() => {
    this.swUpdate.versionUpdates.subscribe((event) => {
     switch (event.type) {
      case 'VERSION_DETECTED':
       this.updateDetected.set(true);
       break;
      case 'VERSION_READY':
       this.updateReady.set(true);
       break;
      case 'VERSION_INSTALLATION_FAILED':
       console.log('error in installation');
       
       break;
     }
    });
   });
  }
 }

 activateUpdate() {
  this.swUpdate.activateUpdate().then(() => location.reload());
 }
}
